/* global axios */
// Nút "Sửa cấu hình" trên trang Settings → Integrations → TinoFone + MODAL sửa
// settings — giao diện BÁM modal integration native của Chatwoot (Google Translate,
// Dashboard Apps): backdrop mờ, hộp trắng giữa màn hình, input xám bo tròn, Huỷ/Cập nhật.
//
// Vì sao cần: form native của integration hook CHỈ hiện lúc "Kết nối" — sau đó Chatwoot
// không có UI sửa settings (muốn sửa phải Ngắt kết nối, mất dữ liệu đã nhập). Modal này
// đọc hook voice_acd + PATCH settings trực tiếp. Không patch .vue core — DOM tự chứa.
//
// Nhóm nhận cuộc gọi: bảng dòng (Tên / mã / phím IVR) thêm-xoá trực quan, tự
// serialize thành groups_json — admin không phải gõ JSON tay.

const EDIT_BTN_ID = 'cw-voice-config-edit-btn';
const MODAL_ID = 'cw-voice-config-modal';
const DEFAULT_GROUPS = [
  { key: 'kd', name: 'Kinh doanh', digit: '1' },
  { key: 'hotro', name: 'Hỗ trợ', digit: '2' },
];

let started = false;
let hookId = null;

function accountId() {
  const path = window.location.pathname;
  return path.includes('/app/accounts') ? path.split('/')[3] : '';
}

function onVoiceAcdPage() {
  return /\/settings\/integrations\/voice_acd\/?$/.test(window.location.pathname);
}

async function loadHook() {
  const { data } = await axios.get(
    `/api/v1/accounts/${accountId()}/integrations/apps`
  );
  const app = (data.payload || []).find(a => a.id === 'voice_acd');
  const hook = app?.hooks?.[0];
  hookId = hook?.id || null;
  return hook?.settings || {};
}

async function saveSettings(settings) {
  const base = `/api/v1/accounts/${accountId()}/integrations/hooks`;
  if (hookId) {
    await axios.patch(`${base}/${hookId}`, { settings });
  } else {
    const { data } = await axios.post(base, { app_id: 'voice_acd', settings });
    hookId = data?.id || data?.payload?.id || null;
  }
}

function parseGroups(settings) {
  try {
    const list = JSON.parse(settings.groups_json || '');
    if (Array.isArray(list) && list.length) return list;
  } catch (e) {
    /* JSON hỏng/rỗng → default */
  }
  return DEFAULT_GROUPS.map(g => ({ ...g }));
}

// ===== DOM helpers — style bám form native Chatwoot =====

const INPUT_CSS =
  'width:100%;padding:11px 16px;border:1px solid transparent;border-radius:12px;' +
  'font-size:14px;line-height:1.4;background:rgba(27,31,38,.05);color:#1f2328;' +
  'outline:none;box-sizing:border-box;transition:border-color .15s;';
const LABEL_CSS = 'font-size:14px;font-weight:500;color:#1f2328;';
const HELP_CSS = 'font-size:12px;color:#6e7681;';

function el(tag, css, text) {
  const node = document.createElement(tag);
  if (css) node.style.cssText = css;
  if (text != null) node.textContent = text;
  return node;
}

function mkInput() {
  const input = el('input', INPUT_CSS);
  input.addEventListener('focus', () => (input.style.borderColor = '#2781F6'));
  input.addEventListener('blur', () => (input.style.borderColor = 'transparent'));
  return input;
}

function labeledInput(label, value, { placeholder = '', help = '', flex = '1' } = {}) {
  const wrap = el('div', `display:flex;flex-direction:column;gap:6px;flex:${flex};min-width:0;`);
  wrap.appendChild(el('label', LABEL_CSS, label));
  const input = mkInput();
  input.value = value == null ? '' : String(value);
  input.placeholder = placeholder;
  wrap.appendChild(input);
  if (help) wrap.appendChild(el('span', HELP_CSS, help));
  wrap.input = input;
  return wrap;
}

// Bảng nhóm: mỗi dòng Tên | mã | phím | Xoá.
function groupsEditor(groups) {
  const box = el('div', 'display:flex;flex-direction:column;gap:8px;');
  box.appendChild(el('label', LABEL_CSS, 'Nhóm nhận cuộc gọi (tên / mã / phím IVR khách bấm)'));
  const rowsWrap = el('div', 'display:flex;flex-direction:column;gap:8px;');
  box.appendChild(rowsWrap);

  const rows = [];
  const addRow = g => {
    const row = el('div', 'display:flex;gap:8px;align-items:center;');
    const mk = (val, ph, flex) => {
      const i = mkInput();
      i.style.flex = flex;
      i.style.minWidth = '0';
      i.value = val || '';
      i.placeholder = ph;
      return i;
    };
    const name = mk(g.name, 'Tên nhóm (vd Kinh doanh)', '3');
    const key = mk(g.key, 'mã (a-z, số)', '2');
    const digit = mk(g.digit, 'phím', '1');
    const del = el('button', 'flex:none;border:none;background:rgba(239,68,68,.1);color:#ef4444;border-radius:10px;padding:10px 14px;cursor:pointer;font-size:13px;', 'Xoá');
    del.type = 'button';
    del.addEventListener('click', () => {
      rowsWrap.removeChild(row);
      rows.splice(rows.indexOf(entry), 1);
    });
    const entry = { name, key, digit };
    rows.push(entry);
    row.append(name, key, digit, del);
    rowsWrap.appendChild(row);
  };
  groups.forEach(addRow);

  const add = el('button', 'align-self:flex-start;border:1px dashed #b9c0c8;background:none;border-radius:10px;padding:8px 14px;cursor:pointer;font-size:13px;color:#57606a;', '+ Thêm nhóm');
  add.type = 'button';
  add.addEventListener('click', () => addRow({ name: '', key: '', digit: '' }));
  box.appendChild(add);
  box.appendChild(el('span', HELP_CSS, 'Không có nhóm nào gán phím = bỏ menu IVR, đổ chuông ngay sau lời chào.'));

  box.serialize = () =>
    JSON.stringify(
      rows
        .map(r => ({
          key: r.key.value.trim().toLowerCase(),
          name: r.name.value.trim(),
          digit: r.digit.value.trim(),
        }))
        .filter(g => g.key)
    );
  return box;
}

// ===== Modal (bám modal integration native) =====

async function openModal() {
  if (document.getElementById(MODAL_ID)) return;
  const settings = await loadHook().catch(() => ({}));

  const backdrop = el('div',
    'position:fixed;inset:0;z-index:2147483100;background:rgba(15,17,20,.55);' +
    'display:flex;align-items:center;justify-content:center;padding:24px;');
  backdrop.id = MODAL_ID;
  backdrop.addEventListener('click', e => { if (e.target === backdrop) backdrop.remove(); });

  const dialog = el('div',
    'background:#fff;border-radius:16px;box-shadow:0 24px 64px rgba(0,0,0,.25);' +
    'width:100%;max-width:640px;max-height:88vh;overflow-y:auto;padding:28px 32px;' +
    'display:flex;flex-direction:column;gap:16px;font-family:inherit;color:#1f2328;');
  backdrop.appendChild(dialog);

  const head = el('div', 'display:flex;align-items:flex-start;justify-content:space-between;');
  const titleBox = el('div', 'display:flex;flex-direction:column;gap:4px;');
  titleBox.appendChild(el('h3', 'margin:0;font-size:17px;font-weight:700;', 'Cấu hình tổng đài TinoFone'));
  titleBox.appendChild(el('p', 'margin:0;font-size:13px;color:#6e7681;', 'Áp dụng riêng cho account này, có hiệu lực với cuộc gọi tiếp theo (~30 giây).'));
  const closeBtn = el('button', 'border:none;background:none;font-size:20px;cursor:pointer;color:#57606a;line-height:1;', '✕');
  closeBtn.type = 'button';
  closeBtn.addEventListener('click', () => backdrop.remove());
  head.append(titleBox, closeBtn);
  dialog.appendChild(head);

  const hotline = labeledInput('Đầu số hotline (cách nhau dấu phẩy)', settings.hotline_numbers, { placeholder: '18006734, 0364333333' });
  const groups = groupsEditor(parseGroups(settings));
  const row2 = el('div', 'display:flex;gap:12px;');
  const poolStart = labeledInput('Máy nhánh — số bắt đầu', settings.ext_pool_start || 2001);
  const poolSize = labeledInput('Số máy nhánh (trực đồng thời)', settings.ext_pool_size || 10);
  row2.append(poolStart, poolSize);
  const greeting = labeledInput('Lời chào — URL file WAV (PCM 16-bit 8kHz mono)', settings.greeting_url, { placeholder: 'https://.../loi-chao.wav', help: 'Bỏ trống = lời chào mặc định trên tổng đài.' });
  const menu = labeledInput('Menu IVR — URL file WAV', settings.ivr_menu_url, { placeholder: 'https://.../menu-ivr.wav', help: 'File đọc "nhấn 1 gặp..., nhấn 2 gặp...". Bỏ trống = menu mặc định.' });
  const row3 = el('div', 'display:flex;gap:12px;');
  const ring = labeledInput('Đổ chuông tối đa mỗi agent (giây)', settings.ring_timeout_seconds || 30);
  const queueWait = labeledInput('Khách chờ hàng đợi tối đa (giây)', settings.max_queue_wait_seconds || 120);
  row3.append(ring, queueWait);
  dialog.append(hotline, groups, row2, greeting, menu, row3);

  const footer = el('div', 'display:flex;align-items:center;justify-content:flex-end;gap:10px;margin-top:4px;');
  const status = el('span', 'font-size:13px;margin-right:auto;');
  const cancel = el('button', 'border:none;background:rgba(27,31,38,.06);color:#1f2328;border-radius:10px;padding:10px 20px;cursor:pointer;font-size:14px;font-weight:500;', 'Huỷ');
  cancel.type = 'button';
  cancel.addEventListener('click', () => backdrop.remove());
  const save = el('button', 'border:none;background:#2781F6;color:#fff;border-radius:10px;padding:10px 22px;cursor:pointer;font-size:14px;font-weight:600;', 'Cập nhật');
  save.type = 'button';
  save.addEventListener('click', async () => {
    status.textContent = 'Đang lưu...';
    status.style.color = '#2781F6';
    try {
      await saveSettings({
        enabled: true,
        hotline_numbers: hotline.input.value.trim(),
        groups_json: groups.serialize(),
        ext_pool_start: poolStart.input.value.trim(),
        ext_pool_size: poolSize.input.value.trim(),
        greeting_url: greeting.input.value.trim(),
        ivr_menu_url: menu.input.value.trim(),
        ring_timeout_seconds: ring.input.value.trim(),
        max_queue_wait_seconds: queueWait.input.value.trim(),
      });
      status.textContent = '✓ Đã lưu';
      status.style.color = '#0a7d5e';
      setTimeout(() => backdrop.remove(), 900);
    } catch (e) {
      status.textContent = `Lỗi: ${e?.response?.data?.error || e?.message || e}`;
      status.style.color = '#ef4444';
    }
  });
  footer.append(status, cancel, save);
  dialog.appendChild(footer);

  document.body.appendChild(backdrop);
}

// ===== Nút "Sửa cấu hình" cạnh nút Ngắt kết nối trên card =====

function injectEditButton() {
  if (!onVoiceAcdPage()) {
    document.getElementById(EDIT_BTN_ID)?.remove();
    return;
  }
  if (document.getElementById(EDIT_BTN_ID)) return;
  // Chỉ hiện khi ĐÃ kết nối (có nút Ngắt kết nối). Chưa kết nối → form native lo.
  const disconnectBtn = [...document.querySelectorAll('button')].find(b =>
    /Ngắt kết nối|Disconnect/i.test((b.textContent || '').trim()));
  if (!disconnectBtn || !disconnectBtn.parentElement) return;

  const btn = el('button',
    'margin-right:10px;border:1px solid rgba(27,31,38,.15);background:#fff;color:#1f2328;' +
    'border-radius:10px;padding:9px 18px;cursor:pointer;font-size:14px;font-weight:500;',
    'Sửa cấu hình');
  btn.id = EDIT_BTN_ID;
  btn.type = 'button';
  btn.addEventListener('click', () => openModal().catch(() => {}));
  disconnectBtn.parentElement.insertBefore(btn, disconnectBtn);
}

function isAdmin(store) {
  try {
    const u = store?.getters?.getCurrentUser;
    const role = u?.role || u?.accounts?.find(a => `${a.id}` === accountId())?.role;
    return role === 'administrator';
  } catch (e) {
    return false;
  }
}

export function startVoiceIntegrationConfig(store) {
  if (started || !isAdmin(store)) return;
  started = true;
  const mo = new MutationObserver(() => injectEditButton());
  mo.observe(document.body, { childList: true, subtree: true });
  setInterval(injectEditButton, 2000); // route SPA đổi không phải lúc nào cũng trigger MO
  injectEditButton();
}

export default startVoiceIntegrationConfig;
